// src/pages/meeting/NoticeCreate.jsx
import React, { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TinyMCEeditor from "../../../components/const/TinyMCEeditor";
import { createNotice } from "../../../api/meeting";
import PageHeader from "../../../components/common/ui/PageHeader";

// PMIS 공통 입력 스타일
const inputCls = "input-base w-full";
const labelCls = "text-sm font-medium text-slate-700 mb-1";

export default function NoticeCreate() {
  const navigate = useNavigate();
  const editorRef = useRef(null);
  const { id: projectId } = useParams();

  const [title, setTitle] = useState("");

  const handleSubmit = async () => {
    const context = editorRef.current ? editorRef.current.getContent() : "";

    if (!title.trim()) {
      alert("제목을 입력해주세요.");
      return;
    }

    try {
      await createNotice({
        title,
        project: projectId,
        context,
      });

      alert("공지사항이 생성되었습니다.");
      navigate(-1);
    } catch (error) {
      console.error(error);
      alert("생성에 실패했습니다.");
    }
  };

  return (
    <div className="p-6 space-y-4">
      <PageHeader showBack>새 공지 작성</PageHeader>

      {/* ============================
          ACTION BUTTONS
      ============================ */}
      <div className="flex justify-end gap-2">
        <button
          onClick={handleSubmit}
          className="btn-create"
        >
          생성하기
        </button>

        <button
          onClick={() => navigate(-1)}
          className="btn-basic"
        >
          취소
        </button>
      </div>
      {/* ============================
    TITLE + CONTENT IN ONE CARD
============================ */}
      <div className="border rounded-lg bg-white p-5 space-y-5">

        {/* 제목 */}
        <div>
          <div className={labelCls}>제목</div>
          <input
            type="text"
            value={title}
            className={inputCls}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="제목을 입력하세요"
          />
        </div>

        {/* 구분선 */}
        <div className="h-px bg-gray-200"></div>

        {/* 내용 */}
        <div>
          <div className="text-sm font-medium text-slate-700 mb-2">내용</div>
          <TinyMCEeditor initialValue="" editorRef={editorRef} />
        </div>

      </div>

    </div>
  );
}
